import React, { Fragment, useState } from "react";
import { FAQs } from "../FAQs";
import { ImageContent } from "../ImageContent";
import ListBox from "../ListBox/ListBox";
import ImageOverBanner from "../../ImageOverBanner";

const Tabs = ({ data }) => {
  const { tabContent } = data;
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="flex flex-wrap items-center justify-center gap-10">
      <div className="flex w-full basis-full flex-wrap items-center justify-center">
        {tabContent?.map((tab, index) => (
          <button
            key={index}
            className={`inline-block py-4 px-12 font-openSans text-2xl ${
              activeTab === index
                ? "bg-lightgrey text-secondary"
                : "bg-submenugrey text-black hover:bg-lightgrey hover:text-secondary"
            }`}
            onClick={(e) => {
              e.preventDefault();
              setActiveTab((prevState) => index);
            }}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className="flex w-full basis-full flex-wrap">
        {tabContent?.map((tab, index) => {
          return (
            <div
              key={index}
              className={`w-full basis-full py-4 px-4 ${
                activeTab === index ? "block" : "hidden"
              }`}
            >
              {tab.commonContent && (
                <div
                  className="page-content mb-8 w-full basis-full px-4 font-openSans text-xl text-black"
                  dangerouslySetInnerHTML={{ __html: tab.commonContent }}
                ></div>
              )}
              {tab.contentType === "twoColumn" ? (
                <div className="flex flex-wrap">
                  <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                    {tab.column1?.map((column, columnIndex) => (
                      <Fragment key={columnIndex}>
                        {column.title && (
                          <h4 className="mb-4 mt-6 font-openSans text-xl text-black">
                            {column.title}
                          </h4>
                        )}
                        {column.content && (
                          <div
                            className="page-content font-openSans text-xl text-black"
                            dangerouslySetInnerHTML={{ __html: column.content }}
                          ></div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                  <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                    {tab.column2?.map((column, columnIndex) => (
                      <Fragment key={columnIndex}>
                        {column.title && (
                          <h4 className="mb-4 mt-6 font-openSans text-xl text-black">
                            {column.title}
                          </h4>
                        )}
                        {column.content && (
                          <div
                            className="page-content font-openSans text-xl text-black"
                            dangerouslySetInnerHTML={{ __html: column.content }}
                          ></div>
                        )}
                      </Fragment>
                    ))}
                  </div>
                </div>
              ) : tab.contentType === "imageContent" ? (
                <>
                  <ImageContent
                    data={{
                      ...(tab?.imageContent || {}),
                    }}
                    {...(tab?.imageContent?.titlePosition ||
                    tab?.imageContent?.titleColor
                      ? {
                          titleProps: {
                            position:
                              tab?.imageContent?.titlePosition || "section",
                            color: tab?.imageContent?.titleColor || "primary",
                            className: "text-center",
                          },
                        }
                      : {})}
                    contentContainerClassName="lg:w-7/12 lg:basis-7/12 px-0"
                    imageContainerClassName="lg:w-5/12 lg:basis-5/12 px-4"
                  />
                  {tab?.imageContent?.showBannerWithText &&
                    tab?.imageContent?.bannerWithText && (
                      <ImageOverBanner
                        data={{
                          ...tab?.imageContent?.bannerWithText,
                          bannerImage: tab?.imageContent?.bannerWithText?.image,
                        }}
                        className="px-0"
                        bannerClassName="h-auto lg:h-[487px] bg-left"
                      />
                    )}
                  {tab?.imageContent?.showBelowImageContent &&
                    tab?.imageContent?.belowImageContent && (
                      <div
                        className="mt-6 font-openSans text-lg text-black 2xl:text-xl"
                        dangerouslySetInnerHTML={{
                          __html: tab?.imageContent?.belowImageContent,
                        }}
                      ></div>
                    )}
                </>
              ) : tab.contentType === "listBox" ? (
                <ListBox
                  data={tab?.listBox}
                  addContainer={true}
                  className="pt-12 pb-0"
                />
              ) : tab.contentType === "faq" ? (
                <FAQs data={tab.faqs} />
              ) : (
                ""
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
